import Vue from 'vue';
import _ from 'lodash';
import { db, docsFromSnapshot, docFromSnapshot } from '@/firebase';

const state = {
  services: {}
};

const getters = {
  servicesList: state => _.sortBy(state.services, 'name'),
  availableServices: state =>
    _.reduce(
      Object.values(state.services),
      (services, service) => {
        if (service.enabled) services[service.id] = service;
        return services;
      },
      {}
    ),
  serviceById: state => id => state.services[id]
};

const mutationTypes = {
  SET_SERVICES: 'SET_SERVICES',
  SET_SERVICE: 'SET_SERVICE',
  REMOVE_SERVICE: 'REMOVE_SERVICE'
};

const actions = {
  async createService(context, service) {
    service.storeId = context.rootGetters['stores/storeId'];
    service.timestamp = +new Date();
    service.created = service.timestamp;

    const ref = db.collection('services').doc();
    service._id = ref.id;

    await ref.set(service);

    context.commit(mutationTypes.SET_SERVICE, service);
  },
  async fetchServices(context) {
    const snap = await db
      .collection('services')
      .where('storeId', '==', context.rootGetters['stores/storeId'])
      .get();

    context.commit(mutationTypes.SET_SERVICES, docsFromSnapshot(snap));
  },
  async fetchService(context, id) {
    const snap = await db
      .collection('services')
      .doc(id)
      .get();

    context.commit(mutationTypes.SET_SERVICE, docFromSnapshot(snap));
  },
  async updateService(context, service) {
    await db
      .collection('services')
      .doc(service._id)
      .set(service);

    context.commit(mutationTypes.SET_SERVICE, service);
  },
  async deleteService(context, { _id }) {
    await db
      .collection('services')
      .doc(_id)
      .delete();

    context.commit(mutationTypes.REMOVE_SERVICE, _id);
  }
};

const mutations = {
  [mutationTypes.SET_SERVICES](state, services) {
    state.services = services;
  },
  [mutationTypes.SET_SERVICE](state, service) {
    Vue.set(state.services, service._id, service);
  },
  [mutationTypes.REMOVE_SERVICE](state, id) {
    state.services = _.omit(state.services, [id]);
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
